import {AlertTypeDTO} from 'kashable-mobile-common';

export class NotificationUtil {
    /**
     * Get banner notifications from a list of alerts/notifications
     * @param notifications - Array of AlertTypeDTO
     * @returns Array of banner notifications
     */
    static getBanners(notifications: AlertTypeDTO[] | undefined): AlertTypeDTO[] {
        if (!notifications) return [];
        return notifications.filter(notification => notification.banner);
    }

    /**
     * Get regular (non-banner) notifications from a list of alerts/notifications
     * @param notifications - Array of AlertTypeDTO
     * @returns Array of regular notifications
     */
    static getRegularNotifications(notifications: AlertTypeDTO[] | undefined): AlertTypeDTO[] {
        if (!notifications) return [];
        return notifications.filter(notification => !notification.banner);
    }
}
